import React from 'react';
import { UseControllerProps } from 'react-hook-form/dist/types/controller';
import { GroupBase } from 'react-select/dist/declarations/src/types';

import { FormGroupEssentialProps } from '../../../components';
import { AsyncSelect, AsyncSelectProps } from '../../../components/Select/AsyncSelect/AsyncSelect';

import { ConnectedComponentProps, ConnectHelper } from './ConnectHelper';

export type FormAsyncSelectProps<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
> = AsyncSelectProps<Option, IsMulti, Group> &
  FormGroupEssentialProps & { name: string; rules?: UseControllerProps['rules'] };

function AsyncSelectInner<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({ componentProps, controllerField }: ConnectedComponentProps<FormAsyncSelectProps<Option, IsMulti, Group>>) {
  return (
    <AsyncSelect
      {...componentProps}
      {...controllerField}
      onChange={(value, meta) => {
        controllerField?.onChange(value);
        componentProps?.onChange?.(value, meta);
      }}
      onBlur={(e) => {
        controllerField?.onBlur();
        componentProps.onBlur?.(e);
      }}
    />
  );
}

export function ConnectedAsyncSelect<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: FormAsyncSelectProps<Option, IsMulti, Group>) {
  return (
    <ConnectHelper<FormAsyncSelectProps<Option, IsMulti, Group>>
      defaultValue={null}
      {...props}
      RenderComponent={AsyncSelectInner}
    />
  );
}
